'use strict';

var chunkHIHYWLJZ_js = require('./chunk-HIHYWLJZ.js');

var m=t=>t?t.trim()==="":!0;var l=t=>!t||t<1?"50%":`calc(50% + ${chunkHIHYWLJZ_js.a(t/2)})`,y=(t,r,o,u)=>{let n=[];return t.map((a,e)=>{let s=e>0?t[e-1]:0;n.push(f(a,s,r,o,u));}),n},f=(t,r,o,u,n)=>o||(n&&u?"100%":t&&t!=="auto"?`${Math.round(t/12*1e8)/1e6}%`:t==="auto"?"auto":r?.toString()!=="0"&&r!=="auto"&&!m(r?.toString())?`${Math.round(r/12*1e8)/1e6}%`:"100%");

exports.a = l;
exports.b = y;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-JHC2E647.js.map